import type { PropsWithChildren } from "react";
import React from "react";

export const Heading = ({ children }: PropsWithChildren) => {
  return (
    <h2 className="text-2xl font-semibold text-secondary-20 dark:text-primary">
      {children}
    </h2>
  );
};
